/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type TranscodingJobStatus = typeof TranscodingJobStatus[keyof typeof TranscodingJobStatus];


export const TranscodingJobStatus = {
  pending: 'pending',
  requested: 'requested',
  succeeded: 'succeeded',
  failed: 'failed',
  superseded: 'superseded',
} as const;
